import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13.042 7.2h-2.1l.07 6.762h1.974zm-2.324 8.68c0 .7.56 1.26 1.274 1.26.728 0 1.288-.56 1.288-1.26s-.56-1.246-1.288-1.246c-.714 0-1.274.546-1.274 1.246"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
      clipRule: "evenodd"
    }
  )
);
var SvgWarningOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WarningOutlined_default = SvgWarningOutlined;

export { WarningOutlined_default as default };
